<template>
  <a-modal
    :visible="open"
    :title="title"
    :confirmLoading="submitLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    width="500px"
  >
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-form-model-item label="发放积分" prop="score">
        <a-input-number
          v-model="form.score"
          :min="1"
          :max="999999"
          :precision="0"
          style="width: 100%"
          placeholder="请输入发放积分数量"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea
          v-model="form.remark"
          :maxLength="200"
          placeholder="请输入发放备注"
          :rows="4"
          allow-clear
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { batchSendScore } from '@/api/biz/user'

export default {
  name: 'BatchSendScoreModal',
  data() {
    return {
      open: false,
      title: '发放积分',
      submitLoading: false,
      userId: null,
      form: {
        score: undefined,
        remark: ''
      },
      rules: {
        score: [
          { required: true, message: '请输入发放积分数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '积分数量必须大于0', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入发放备注', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModal(userId) {
      debugger
      this.userId = userId
      this.open = true
      this.form = {
        score: undefined,
        remark: ''
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const data = {
            userId: this.userId,
            score: this.form.score,
            remark: this.form.remark
          }
          batchSendScore(data).then(response => {
            this.$message.success('批量发放积分成功', 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleCancel() {
      this.open = false
      this.form = {
        score: undefined,
        remark: ''
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    }
  }
}
</script>
